import * as qsParser from "query-string";

export function getQueryParams(queryString: string) {
  return qsParser.parse(queryString, {
    ignoreQueryPrefix: true
  } as qsParser.ParseOptions);
}

export function stringifyQueryParams(queryParams: any) {
  return qsParser.stringify(queryParams);
}

export function currencyFormatter(
  amount: any,
  locale?: any,
  currency?: string,
  minFractionDigits?: number
) {
  if (typeof locale === "undefined") {
    locale = "en-IN";
  }
  if (typeof currency === "undefined") {
    currency = "INR";
  }
  if (typeof minFractionDigits === "undefined") {
    minFractionDigits = 0;
  }
  if (typeof amount === "undefined") {
    amount = 0;
  }

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: minFractionDigits
  });
  return formatter.format(amount);
}

export function getFullName(
  firstName?: string | null,
  lastName?: string | null
) {
  return [firstName, lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
}
